import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type UpdateMileagesPayload = {
  current_km?: number;
  next_km?: number;
};

export const useAppointmentUpdateMileagesMutation = (appointment_id: number) => {
  const { t } = useTranslation();

  return useTypedMutation<UpdateMileagesPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/appointments/update_mileages", { appointment_id, ...payload });
    },
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, ...payload });
    },
    onError: e => toast.error(e.message.startsWith("v8_") ? t(e.message) || e.message : e.message)
  });
};
